import { z } from 'zod';

export const CalibrationFraming = z
  .enum(['bias', 'optimization'])
  .describe('CalibrationFraming');

export type CalibrationFraming = z.infer<typeof CalibrationFraming>;

export const DefaultCalibrationFraming = 'bias' as CalibrationFraming;

export const CalibrationFramings = Object.values(CalibrationFraming.Values);
